import React from "react";

interface Props {
  className?: string;
  containerClassName?: string;
  color?: string;
}

const UploadIcon = ({className, color, containerClassName}: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={containerClassName}
  >
    <path
      d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z"
      fill={color || "black"}
      className={className}
    />
  </svg>
);
UploadIcon.defaultProps = {
  className: "",
  color: "",
  containerClassName: "",
};

export default UploadIcon;
